import * as React from "react";
import { Container, Button, Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { toast } from "react-toastify";
import { InvoiceService } from "../../Common/Services/InvoiceService";
import { Utils } from "../../Common/Utilis";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { Document, pdfjs } from "react-pdf";
import { API_ROOT } from "../../Common/Services/Api-config";
import Instense from "../../Common/Services/Axios-config";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

const { SearchBar } = Search;

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface DraftInboxItem {
  id: number;
  receivedDate: string;
  vendor: string;
  uploadedBy: string;
  type: string; // ACH or Check
  filename: string;
  pages: number;
  attachmentUrl?: string;
  attachmentId?: number;
  extractedVendorName?: string;
  extractedInvoiceAmount?: number;
}

export class DraftInbox extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      draftInboxItems: [],
      originalDraftInboxItems: [],
      isSpinner: false,
      selectedcolumn: "All",
      selectOptions: [
        { id: 'All', name: 'All' },
        { id: 'Received Date', name: 'Received Date' },
        { id: 'Vendor', name: 'Vendor' },
        { id: 'Uploaded By', name: 'Uploaded By' },
        { id: 'Type', name: 'Type' },
        { id: 'Filename', name: 'Filename' },
      ],
      isReceivedDate: true,
      isVendor: true,
      isUploadedBy: true,
      isType: true,
      isFilename: true,
    };
  }

  componentDidMount() {
    this.getDraftInboxItems();
  }

  getDraftInboxItems = () => {
    this.setState({ isSpinner: true });
    let saveRequest: any = {};
    saveRequest.recordCount = 0;

    InvoiceService.GetAllDraftInbox(saveRequest)
      .then(async (result: any[] | null) => {
        if (result != null && result.length > 0) {
          // Process each item to extract PDF data
          const processedItems = await Promise.all(
            result.map(async (item: any) => {
              const processedItem: DraftInboxItem = {
                id: item.Id || item.id || item.AttachmentId || item.attachmentId || 0,
                receivedDate: item.ReceivedDate || item.receivedDate || item.date || new Date().toISOString(),
                vendor: item.Vendor || item.vendor || item.Sender || item.sender || '',
                uploadedBy: item.UploadedBy || item.uploadedBy || item.Sender || item.sender || '',
                type: this.detectTypeFromFilename(item.Filename || item.filename || ''),
                filename: item.Filename || item.filename || '',
                pages: item.Pages || item.pages || 0,
                attachmentUrl: item.AttachmentUrl || item.attachmentUrl || item.fileUrl || '',
                attachmentId: item.AttachmentId || item.attachmentId || item.Id || item.id,
              };

              // Only process PDF files
              if (processedItem.filename.toLowerCase().endsWith('.pdf')) {
                // Get page count if not available
                if (!processedItem.pages && processedItem.attachmentUrl) {
                  try {
                    processedItem.pages = await this.getPDFPageCount(processedItem.attachmentUrl);
                  } catch (error) {
                    console.error('Error getting PDF page count:', error);
                  }
                }

                // Extract data from PDF if available
                if (processedItem.attachmentUrl) {
                  try {
                    const extractedData = await this.extractPDFData(processedItem.attachmentUrl);
                    processedItem.extractedVendorName = extractedData.vendorName;
                    processedItem.extractedInvoiceAmount = extractedData.invoiceAmount;
                    // Update vendor if extracted and not already set
                    if (extractedData.vendorName && (!processedItem.vendor || processedItem.vendor === '')) {
                      processedItem.vendor = extractedData.vendorName;
                    }
                  } catch (error) {
                    console.error('Error extracting PDF data:', error);
                  }
                }
              }

              return processedItem;
            })
          );

          this.setState({
            draftInboxItems: processedItems,
            originalDraftInboxItems: processedItems,
            isSpinner: false,
          });
        } else {
          this.setState({ 
            draftInboxItems: [],
            originalDraftInboxItems: [],
            isSpinner: false 
          });
        }
      })
      .catch((err: any) => {
        toast.error(`Server Error: ${err}`);
        this.setState({ isSpinner: false });
      });
  };

  detectTypeFromFilename = (filename: string): string => {
    const lowerFilename = filename.toLowerCase();
    if (lowerFilename.includes('ach') || lowerFilename.includes('electronic')) {
      return 'ACH';
    } else if (lowerFilename.includes('check') || lowerFilename.includes('cheque')) {
      return 'Check';
    }
    return 'Unknown';
  };

  getPDFPageCount = async (url: string): Promise<number> => {
    try {
      // If URL is relative, prepend the API base URL
      let fullUrl = url;
      if (url.startsWith('/')) {
        fullUrl = `${API_ROOT.backendHost.replace('/api', '')}${url}`;
      }
      
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `bearer ${localStorage.getItem("token")}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const arrayBuffer = await response.arrayBuffer();
      const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
      return pdf.numPages;
    } catch (error) {
      console.error('Error getting PDF page count:', error);
      return 0;
    }
  };

  extractPDFData = async (url: string): Promise<{ vendorName: string; invoiceAmount: number }> => {
    try {
      // If URL is relative, prepend the API base URL
      let fullUrl = url;
      if (url.startsWith('/')) {
        fullUrl = `${API_ROOT.backendHost.replace('/api', '')}${url}`;
      }
      
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `bearer ${localStorage.getItem("token")}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const arrayBuffer = await response.arrayBuffer();
      const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
      
      let fullText = '';
      let vendorName = '';
      let invoiceAmount = 0;

      // Extract text from all pages
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((item: any) => item.str).join(' ');
        fullText += pageText + ' ';
      }

      // Extract vendor name (look for common patterns)
      const vendorPatterns = [
        /(?:vendor|supplier|from|bill from|pay to)[\s:]+([A-Z][A-Za-z\s&,.-]+?)(?:\n|$|invoice|amount|total)/i,
        /^([A-Z][A-Za-z\s&,.-]{3,50})/m, // First capitalized line
        /(?:company|inc|llc|ltd|corp)[\s:]+([A-Z][A-Za-z\s&,.-]+?)/i,
      ];

      for (const pattern of vendorPatterns) {
        const match = fullText.match(pattern);
        if (match && match[1]) {
          vendorName = match[1].trim();
          if (vendorName.length > 3 && vendorName.length < 100) {
            break;
          }
        }
      }

      // Extract invoice amount (look for currency patterns)
      const amountPatterns = [
        /(?:total|amount|invoice total|balance|due)[\s:]*\$?\s*([\d,]+\.?\d*)/i,
        /\$\s*([\d,]+\.?\d{2})/g,
        /(?:total|amount)[\s:]*([\d,]+\.?\d{2})/i,
      ];

      for (const pattern of amountPatterns) {
        const matches = fullText.match(pattern);
        if (matches) {
          const amountStr = matches[matches.length - 1].replace(/,/g, '');
          const amount = parseFloat(amountStr);
          if (!isNaN(amount) && amount > 0) {
            invoiceAmount = amount;
            break;
          }
        }
      }

      // Try to find the largest amount (likely the total)
      const allAmounts = fullText.match(/\$?\s*([\d,]+\.?\d{2})/g);
      if (allAmounts && allAmounts.length > 0) {
        const amounts = allAmounts.map(m => {
          const num = parseFloat(m.replace(/[$,]/g, ''));
          return isNaN(num) ? 0 : num;
        }).filter(n => n > 0);
        if (amounts.length > 0) {
          invoiceAmount = Math.max(...amounts);
        }
      }

      return { vendorName, invoiceAmount };
    } catch (error) {
      console.error('Error extracting PDF data:', error);
      return { vendorName: '', invoiceAmount: 0 };
    }
  };

  handleSelectedItem1 = (control: any, id: any) => {
    let chkisReceivedDate = id === "Received Date" ? true : false;
    let chkisVendor = id === "Vendor" ? true : false;
    let chkisUploadedBy = id === "Uploaded By" ? true : false;
    let chkisType = id === "Type" ? true : false;
    let chkisFilename = id === "Filename" ? true : false;

    if (id === "All") {
      chkisReceivedDate = true;
      chkisVendor = true;
      chkisUploadedBy = true;
      chkisType = true;
      chkisFilename = true;
    }

    this.setState({
      selectedcolumn: id,
      isReceivedDate: chkisReceivedDate,
      isVendor: chkisVendor,
      isUploadedBy: chkisUploadedBy,
      isType: chkisType,
      isFilename: chkisFilename,
    });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      // Handle row click if needed (e.g., open PDF viewer)
      if (row.attachmentUrl) {
        window.open(row.attachmentUrl, '_blank');
      }
    },
  };

  render() {
    const customTotal = (from: number, to: number, size: number) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );

    const options = {
      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: 'All', value: this.state.draftInboxItems.length },
      ],
    };

    const columns = [
      {
        dataField: 'receivedDate',
        text: 'Received Date',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isReceivedDate,
        formatter: (cell: any, row: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.receivedDate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'vendor',
        text: 'Vendor',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isVendor,
        formatter: (cell: any, row: any) => {
          const vendorName = row.extractedVendorName || row.vendor || 'N/A';
          return (
            <EllipsisWithTooltip placement="bottom">
              {vendorName}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'uploadedBy',
        text: 'Uploaded By',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isUploadedBy,
        formatter: (cell: any, row: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.uploadedBy || 'N/A'}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'type',
        text: 'Type',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isType,
        formatter: (cell: any, row: any) => {
          const type = row.type || 'Unknown';
          const badgeClass = type === 'ACH' ? 'badge bg-info' : type === 'Check' ? 'badge bg-warning' : 'badge bg-secondary';
          return (
            <span className={badgeClass}>
              {type}
            </span>
          );
        },
      },
      {
        dataField: 'filename',
        text: 'Filename',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isFilename,
        formatter: (cell: any, row: any) => {
          return (
            <EllipsisWithTooltip placement="bottom" tooltip={row.filename}>
              <a
                href={row.attachmentUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                style={{ color: '#007bff', textDecoration: 'none' }}
              >
                {row.filename}
              </a>
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'pages',
        text: 'Pages',
        classes: 'text-center',
        sort: true,
        headerStyle: { width: '80px' },
        formatter: (cell: any, row: any) => {
          return (
            <span>
              {row.pages || 0}
            </span>
          );
        },
      },
      {
        dataField: 'extractedInvoiceAmount',
        text: 'Invoice Amount',
        classes: 'text-end',
        sort: true,
        headerStyle: { width: '120px' },
        formatter: (cell: any, row: any) => {
          const amount = row.extractedInvoiceAmount || 0;
          return (
            <span>
              {amount > 0 ? Utils.currencyFormat(amount) : 'N/A'}
            </span>
          );
        },
      },
    ];

    return (
      <React.Fragment>
        <Container fluid className="body-sec">
          <div className="page-heading underline d-flex">
            Draft Inbox
            <div className="action-group d-flex flex-row ml-auto">
              <Button onClick={this.getDraftInboxItems} variant="outline-primary">
                Refresh
              </Button>
            </div>
          </div>

          <ToolkitProvider
            keyField="id"
            data={this.state.draftInboxItems}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <section className="d-flex flex-wrap gap-3 pb-2">
                  <div className="position-relative">
                    <SearchBar {...props.searchProps} />
                  </div>
                  <div className="col-12 col-md-2">
                    <SingleDropdownListWithoutSearch
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}
                    />
                  </div>
                </section>

                <section className="pb-3">
                  <div className="table-responsive divbottom">
                    <div className="ml-auto transactions-list">
                      <BootstrapTable
                        id="tblDraftInbox"
                        {...props.baseProps}
                        keyField="id"
                        rowEvents={this.rowEvents}
                        pagination={paginationFactory(options)}
                      />
                    </div>
                  </div>
                </section>
              </div>
            )}
          </ToolkitProvider>

          {this.state.isSpinner && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

